import { IQRCode } from '@nocode/types/';
import { get } from 'lodash';
import { useSignedS3Url } from '@common/hooks/useSignedS3Url';
import React, { useMemo } from 'react';
import { QRCode } from 'react-qr-svg';
import { TouchableOpacity } from 'react-native';
import { getValueBinding, getItemListClick, getActions } from '../shared';
import createStyelse from './style';
import { View } from 'react-native';

const QRCodeGenerate: React.FC<IQRCode> = (props) => {
  const styles = createStyelse(props);
  const { onPress } = props;
  const QRCodeValue = useMemo(() => {
    const isItemList = !!props?.record;
    const bindingValue = getValueBinding(
      isItemList ? props.initId : props.id,
      isItemList ? props?.record : props.data,
      props
    );
    return String(get(bindingValue, 'value', ''));
  }, [props]);

  const handlePress = (id: string) => {
    onPress &&
      onPress(getActions(props, id), {
        itemListClick: getItemListClick(props.record),
      });
  };

  // The value is often a file URL saved on a record, and uploads are stored as
  // pre-signed URLs valid for five minutes - so the code encoded here is
  // usually already dead. Sign again at render.
  //
  // Note this makes the code valid for five minutes FROM RENDER: it fixes
  // scan-it-now, not a printed or forwarded code.
  const signed = useSignedS3Url(QRCodeValue);
  const utf8ForQRCode = unescape(encodeURIComponent(signed.value)).substring(0, 1300);

  const qrHeight =
    props.height === 0 || props.height === null ? 50 : props.height;

  return (
    <>
      {QRCodeValue && signed.ready ? (
        <TouchableOpacity
          style={styles.container}
          onPress={() => handlePress('onPress')}
        >
          <View style={styles.container}>
            <QRCode
              value={utf8ForQRCode}
              bgColor="#FFFFFF"
              fgColor="#000000"
              level="Q"
              style={{ width: qrHeight }}
            />
          </View>
        </TouchableOpacity>
      ) : null}
    </>
  );
};

export default QRCodeGenerate;
